<template>
  <div class="ImmuneTestList">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="queryData">
          <el-input style="width: 150px" placeholder="请输入名称" v-model.trim="queryData.like[0][2]"
            @keyup.enter.native="getDataList(true)" clearable>
          </el-input>
          <el-select v-model="queryData.status" class="inputS" placeholder="状态" @change="getDataList(true)" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button type="success" @click="getDataList">查询</el-button>
          <el-button class="inputR" type="primary" @click="addOrEditPopup(0)">新增分类</el-button>
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%" v-loading="loadingFlag" element-loading-text="正在拼命加载中"
        element-loading-spinner="el-icon-loading" stripe>
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="inspItemsName" label="项目名称" min-width="180">
        </el-table-column>
        <el-table-column prop="itemsName" label="分类名称" min-width="180">
        </el-table-column>
        <!-- <el-table-column prop="itemsNameEn" label="英文名称" min-width="150">
        </el-table-column>
        <el-table-column
          prop="clinicalSignificance"
          label="临床意义"
          min-width="350"
        >
        </el-table-column> -->
        <el-table-column prop="sort" label="排序" min-width="100">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="180">
          <template slot-scope="scope">
            <div>{{ VueDateFormat(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="260">
          <template slot-scope="scope">
            <el-button type="text" @click="addOrEditPopup(scope.row)" style="marin-right: 20px">编辑</el-button>
            <span class="operationLine">|</span>
            <el-button type="text" @click="baseDeleteById(scope.row.id)">删除</el-button>
            <span class="operationLine">|</span>
            <el-button type="text" @click="addOrEditSonPopup(scope.row.id)" style="marin-right: 20px">添加项目</el-button>
            <el-button type="text" @click="opneDetailsPopup(scope.row.id)" style="marin-right: 20px">查看项目</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="getDataListSizeChange" @current-change="getDataListCurrentChange"
        :current-page="queryData.current" :page-sizes="[10, 20, 30, 40]" :page-size="queryData.size"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
    <el-dialog :title="dataForm.id ? '修改' : '新增'" :visible.sync="centerDialogVisible" width="800px" center>
      <el-form ref="dataForm" :model="dataForm" label-width="90px" :rules="dataFormRules">
        <el-form-item prop="inspItemsId" label="项目名称" v-if="!dataForm.fatherId ||
            !(dataForm.fatherId != '0' && dataForm.fatherId)
            ">
          <el-select v-model="dataForm.inspItemsId" placeholder="请选择" clearable>
            <el-option v-for="item in inspItemsList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item prop="fatherId" label="项目分类">
          <el-select
            v-model="dataForm.fatherId"
            placeholder="请选择"
            clearable
            @change="fatherChange"
          >
            <el-option
              v-for="item in fatherList"
              :key="item.id"
              :label="item.itemsName"
              :value="item.id"
              :disabled="item.id == dataForm.id ? true : false"
            >
            </el-option>
          </el-select>
          <div class="formPs">当前项目是分类的情况下不需要选择</div>
        </el-form-item> -->
        <el-form-item prop="itemsName" label="名称">
          <el-input v-model.trim="dataForm.itemsName" placeholder="请输入名称"></el-input>
        </el-form-item>
        <!-- <el-form-item
          prop="itemsNameEn"
          label="英文名称"
          v-if="dataForm.fatherId && dataForm.fatherId != '0'"
        >
          <el-input
            v-model.trim="dataForm.itemsNameEn"
            placeholder="请输入英文名称"
          ></el-input>
        </el-form-item> -->
        <el-form-item prop="clinicalSignificance" label="临床意义" v-if="dataForm.fatherId && dataForm.fatherId != '0'">
          <el-input type="textarea" v-model.trim="dataForm.clinicalSignificance" placeholder="请输入临床意义"></el-input>
        </el-form-item>

        <el-form-item label="显示表头" prop="isShowArr" v-if="!dataForm.fatherId ||
            !(dataForm.fatherId != '0' && dataForm.fatherId)
            ">
          <el-select v-model="dataForm.isShowArr" placeholder="请选择" @change="getDataList(true)" clearable multiple
            style="width: 100%">
            <el-option v-for="item in isShowTabel" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="dataForm.fatherId && dataForm.fatherId != '0'">
          <el-form-item label="IFA" prop="isIFA" v-if="dataForm.isShowArr.includes('1')">
            <el-radio-group v-model="dataForm.isIFA">
              <el-radio :label="1">不选中</el-radio>
              <el-radio :label="2">选中</el-radio>
              <el-radio :label="3">注册中</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="BLOT" prop="isBLOT" v-if="dataForm.isShowArr.includes('2')">
            <el-radio-group v-model="dataForm.isBLOT">
              <el-radio :label="1">不选中</el-radio>
              <el-radio :label="2">选中</el-radio>
              <el-radio :label="3">注册中</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="CLIA" prop="isCLIA" v-if="dataForm.isShowArr.includes('3')">
            <el-radio-group v-model="dataForm.isCLIA">
              <el-radio :label="1">不选中</el-radio>
              <el-radio :label="2">选中</el-radio>
              <el-radio :label="3">注册中</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="ELISA" prop="isELISA" v-if="dataForm.isShowArr.includes('4')">
            <el-radio-group v-model="dataForm.isELISA">
              <el-radio :label="1">不选中</el-radio>
              <el-radio :label="2">选中</el-radio>
              <el-radio :label="3">注册中</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item label="排序" prop="sort">
          <el-input-number :min="1" placeholder="排序" v-model.trim="dataForm.sort"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDataForm" :loading="loadingFlag">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="项目列表" :visible.sync="centerDialogVisible2" width="1200px" center>
      <el-table :data="tableData2" border style="width: 100%" v-loading="loadingFlag" element-loading-text="正在拼命加载中"
        element-loading-spinner="el-icon-loading" stripe>
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="itemsName" label="检测项目名称" min-width="180">
        </el-table-column>
        <!-- <el-table-column prop="itemsNameEn" label="英文名称" min-width="150">
        </el-table-column> -->
        <el-table-column prop="clinicalSignificance" label="临床意义" min-width="350">
        </el-table-column>
        <el-table-column prop="sort" label="排序" min-width="100">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="180">
          <template slot-scope="scope">
            <div>{{ VueDateFormat(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="260">
          <template slot-scope="scope">
            <el-button type="text" @click="addOrEditPopup(scope.row, scope.row.fatherId)"
              style="marin-right: 20px">编辑</el-button>
            <span class="operationLine">|</span>
            <el-button type="text" @click="baseDeleteById(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="getDataListSizeChange2" @current-change="getDataListCurrentChange2"
        :current-page="queryData2.current" :page-sizes="[10, 20, 30, 40]" :page-size="queryData2.size"
        layout="total, sizes, prev, pager, next, jumper" :total="total2">
      </el-pagination>
      <div style="height: 50px"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      queryData: {
        current: 1,
        size: 10,
        like: [["String", "item_name", ""]],
        // ne: [["String", "father_id", "0"]],
        eq: [["String", "father_id", "0"]],
        orderBy: [["String", "sort", "true"]],
      },
      tableData2: [],
      queryData2: {
        current: 1,
        size: 10,
        like: [["String", "item_name", ""]],
        // ne: [["String", "father_id", "0"]],
        eq: [["String", "father_id", "0"]],
        orderBy: [["String", "sort", "true"]],
      },
      total2: 0,
      dataForm: {
        isShowArr: [],
      },
      total: 0,
      centerDialogVisible: false,
      loadingFlag: false,
      dataFormRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        sort: [{ required: true, message: "请选择排序", trigger: "blur" }],
      },
      statusList: [
        {
          label: "启用",
          value: 1,
        },
        {
          label: "禁用",
          value: 2,
        },
      ],
      fatherList: [],
      inspItemsList: [],
      isShowTabel: [
        {
          label: "IFA",
          value: "1",
        },
        {
          label: "BLOT",
          value: "2",
        },
        {
          label: "CLIA",
          value: "3",
        },
        {
          label: "ELISA",
          value: "4",
        },
      ],
      centerDialogVisible2: false,
    };
  },
  created() { },
  mounted() {
    this.getDataList();

    this.$http.get(`inspection-items/getList`).then((res) => {
      if (res.data.code == 200) {
        let data = res.data.data;
        this.inspItemsList = data;
      }
    });
    this.$http.get(`inspection-items-details/getList`).then((res) => {
      if (res.data.code == 200) {
        let data = res.data.data;
        this.fatherList = data;
      }
    });
  },
  methods: {
    opneDetailsPopup(id) {
      this.queryData2.eq[0][2] = id;
      this.getDataList2(true);
      this.centerDialogVisible2 = true;
    },
    fatherChange(id) {
      let item = this.fatherList.find((item) => item.id == id);
      this.$set(this.dataForm, "isShowArr", item.isShow.split(","));
    },
    // 新增
    addOrEditPopup(row, fatherId) {
      this.centerDialogVisible = true;
      if (row) {
        row.isShowArr = [];
        if (fatherId) {
          this.$http
            .get(`inspection-items-details/baseGetById/${fatherId}`)
            .then((res) => {
              if (res.data.code == 200) {
                let data = res.data.data;
                if (data) {
                  let isShowArr = [];
                  if (data.isShow) isShowArr = data.isShow.split(",");
                  this.$set(this.dataForm, "isShowArr", isShowArr);
                }
              }
            });
        } else {
          if (row.isShow) row.isShowArr = row.isShow.split(",");
        }
        this.dataForm = JSON.parse(JSON.stringify(row));
      } else {
        this.dataForm = {
          status: 1,
          isShowArr: [],
        };
      }
      this.$http.get(`inspection-items-details/getList`).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.fatherList = data;
        }
      });
    },
    addOrEditSonPopup(id) {
      this.$http
        .get(`inspection-items-details/baseGetById/${id}`)
        .then((res) => {
          if (res.data.code == 200) {
            let data = res.data.data;
            if (data) {
              let dataForm = {
                status: 1,
                fatherId: id,
                isShowArr: data.isShowArr,
              };
              if (data.isShow) dataForm.isShowArr = data.isShow.split(",");
              else dataForm.isShowArr = [];
              dataForm.inspItemsId = data.inspItemsId;
              this.dataForm = dataForm;
              this.centerDialogVisible = true;
            }
          }
        });
      this.$http.get(`inspection-items-details/getList`).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.fatherList = data;
        }
      });
    },
    /**
     * 删除数据
     */
    baseDeleteById(id) {
      if (id) {
        this.$confirm("是否删除所选择的数据?", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$http
              .delete(`/inspection-items-details/baseDeleteById/${id}`)
              .then((res) => {
                if (res.data.code == 200) {
                  this.getDataList();
                  this.getDataList2(true);
                  this.$VueMessage({
                    type: "success",
                    message: "删除成功!",
                  });
                } else {
                  this.$VueMessage({
                    message: res.data.msg,
                    type: "warning",
                  });
                }
              });
          })
          .catch(() => {
            this.$VueMessage({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    /**
      提交
     */
    submitDataForm() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.loadingFlag = true;
          let url = "/inspection-items-details/saveOrUpdate";
          let data = this.dataForm;
          if (data.isShowArr && data.isShowArr.length > 0) {
            data.isShow = data.isShowArr.join();
          }
          if (data.fatherId && data.fatherId != "0") {
            data.fatherName = this.fatherList.find((item) => {
              return item.id == data.fatherId;
            }).itemsName;
          }
          if (data.inspItemsId) {
            data.inspItemsName = this.inspItemsList.find((item) => {
              return item.id == data.inspItemsId;
            }).title;
          }

          this.$http.post(`${url}`, data).then((res) => {
            this.loadingFlag = false;
            if (res.data.code == 200) {
              this.$VueMessage({
                message: "操作成功",
                type: "success",
              });
              this.centerDialogVisible = false;
              this.getDataList();
              if (data.fatherId) this.getDataList2(true);
              // this.$emit("refreshDataList");
            } else {
              this.$VueMessage({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
        }
      });
    },
    // 查询
    getDataList(flag) {
      let data = this.queryData;
      if (flag) data.current = 1;
      this.loadingFlag = true;
      this.$http
        .post(`/inspection-items-details/page`, this.$guolv(this.queryData))
        .then((res) => {
          this.loadingFlag = false;
          if (res.data.code == 200) {
            let data = res.data.data;
            if (data) {
              let list = data.records;
              this.tableData = list;
              this.total = data.total;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataListSizeChange(val) {
      this.queryData.size = val;
      this.getDataList(true);
    },
    getDataListCurrentChange(val) {
      this.queryData.current = val;
      this.getDataList();
    },

    // 查询
    getDataList2(flag) {
      let data = this.queryData2;
      if (flag) data.current = 1;
      this.loadingFlag = true;
      this.$http
        .post(`/inspection-items-details/page`, this.$guolv(data))
        .then((res) => {
          this.loadingFlag = false;
          if (res.data.code == 200) {
            let data = res.data.data;
            if (data) {
              let list = data.records;
              this.tableData2 = list;
              this.total2 = data.total;
            } else {
              this.tableData2 = [];
              this.total2 = 0;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataListSizeChange2(val) {
      this.queryData2.size = val;
      this.getDataList2(true);
    },
    getDataListCurrentChange2(val) {
      this.queryData2.current = val;
      this.getDataList2();
    },
  },
};
</script>